// Browser download trigger. Creates an object URL, clicks a hidden anchor,
// revokes the URL on the next tick. Works in every modern desktop browser
// (the v1 target); IE-specific fallbacks omitted.

export function triggerDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  // Some browsers require the anchor to be in the DOM to honor click().
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Give the download a moment to start before releasing the blob.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

// Builds a filename like "frame-{boardId}-2026-05-26.{ext}". Avoids
// spaces / special chars so it lands cleanly in shells and email clients.
export function exportFilename(boardId: string, ext: string, now: Date = new Date()): string {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  const safeId = boardId.replace(/[^a-zA-Z0-9-]/g, '-');
  return `frame-${safeId}-${y}-${m}-${d}.${ext}`;
}
